'use strict'

import React, { PureComponent } from 'react'
import FadeIn from 'react-fade-in'
// import 'bootstrap/dist/css/bootstrap-reboot.min.css'
// import 'bootstrap/dist/css/bootstrap-grid.min.css'

import Actions from './components/Actions'
import Footer from './components/Footer'
import Summary from './components/Summary'
import './assets/styles/index.scss'

class App extends PureComponent {
  render() {
    return (
      <FadeIn>
        <div className='container' role='main'>
          <section className='row mb-5 pt-5 pb-1'>
            <div className='col'>
              <h1 className='title'>
                The unique <span className='highlight'>id</span>
              </h1>
            </div>
          </section>
          <Summary />
          <Actions />
        </div>
        <Footer />
      </FadeIn>
    )
  }
}

export default App
